// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3qM1U","signatureBlock":"Footer_signatureBlock__1gUN-","signature":"Footer_signature__1Jh0m"};